import { Grid } from '@material-ui/core';
import React from 'react';
import GroupSelect from './groupSelect';

export default function GroupSelector(props) {
    const { groupId } = props;

    return (
        <Grid container columns={11}>
            <Grid item xs={1}>
                Group:
            </Grid>
            <Grid item xs={5} style={{ paddingRight: '0.5rem' }}>
                <GroupSelect {...props} />
            </Grid>
            <Grid item xs={5}>
                {groupId}
            </Grid>
        </Grid>
    );
}
